// extracted by mini-css-extract-plugin
export default {"container":"_3e7P","text":"_1A5t","alt":"_2nrC","dotOne":"_3q9g","cycleOne":"_35rk","dotTwo":"_3hdx","cycleTwo":"_1tWa","dotThree":"_2y-P","cycleThree":"_3AkQ"};